import { HeaderItem } from "../../../../../types/menu";

export const headerData: HeaderItem[] = [
  { label: "Home", href: "/welcome" },
  { label: "About Us", href: "/about-us" },
  { label: "Services & Products", href: "/services-and-products" },
  { label: "Gallery", href: "/gallery" },
  { label: "FAQ", href: "/faq" },
];
